/** The parts of a name this needs. Matches the shape `get_user` returns. */
export interface NamedUser {
  name?: string;
  given_name?: string;
  family_name?: string;
}

/** Shown when the identity provider sent no usable name at all. */
export const UNNAMED_USER = "Signed in";

/**
 * How a person is named in the chrome: first initial, then surname.
 */
export function displayUserName(user: NamedUser | null | undefined): string {
  const given = user?.given_name?.trim();
  const family = user?.family_name?.trim();

  if (given && family) {
    return `${given[0]!.toUpperCase()}. ${family}`;
  }

  return user?.name?.trim() || UNNAMED_USER;
}

/**
 * Two letters for an avatar. Initials of the given and family name where the identity provider
 * supplied them, otherwise of the first two words of the display name.
 */
export function userInitials(user: NamedUser | null | undefined): string {
  const given = user?.given_name?.trim();
  const family = user?.family_name?.trim();

  if (given && family) {
    return `${given[0]!}${family[0]!}`.toUpperCase();
  }

  const words = user?.name?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (words.length > 0) {
    return words
      .slice(0, 2)
      .map((word) => word[0]!)
      .join("")
      .toUpperCase();
  }

  return "?";
}
